// hooks/useDisableZoom.js

import { useEffect } from 'react';

export const useDisableZoom = () => {
  useEffect(() => {
    const handleKeyDown = (event: { ctrlKey: any; key: string; preventDefault: () => void }) => {
      if (event.ctrlKey && ['+', '-', '=', '0'].includes(event.key)) {
        event.preventDefault();
      }
    };

    const handleWheel = (event: { ctrlKey: any; preventDefault: () => void }) => {
      if (event.ctrlKey) {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('wheel', handleWheel, {
      passive: false,
    });

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('wheel', handleWheel);
    };
  }, []);
};
